function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { Cancel } from '@material-ui/icons';
import { InputAdornment, IconButton } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import { format } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import { MuiPickersUtilsProvider, DateTimePicker as MUIDateTimePicker, DatePicker, TimePicker } from '@material-ui/pickers';
import IconWrapper from '../../lib/IconWrapper';
import useFormHelpers from '../../hooks/useFormHelpers';

const DateTimePicker = ({
  clearable,
  dateOnly,
  icon,
  initialFocusedDate,
  maxDate,
  minDate,
  onChange,
  timeOnly,
  timezone,
  value,
  valueFormat,
  ...props
}) => {
  timezone = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  value = value ? utcToZonedTime(value, timezone) : null;
  minDate = minDate ? utcToZonedTime(minDate, timezone) : undefined;
  maxDate = maxDate ? utcToZonedTime(maxDate, timezone) : undefined;
  initialFocusedDate = initialFocusedDate ? utcToZonedTime(initialFocusedDate, timezone) : undefined;
  const Picker = timeOnly ? TimePicker : dateOnly ? DatePicker : MUIDateTimePicker;
  return React.createElement(IconWrapper, {
    icon: icon
  }, React.createElement(MuiPickersUtilsProvider, {
    utils: DateFnsUtils
  }, React.createElement(Picker, _extends({
    value: value,
    onChange: date => {
      date = zonedTimeToUtc(date, timezone);
      onChange(valueFormat ? format(date, valueFormat) : date);
    },
    minDate: minDate,
    maxDate: maxDate,
    initialFocusedDate: initialFocusedDate,
    fullWidth: true,
    InputProps: {
      endAdornment: clearable && value ? React.createElement(InputAdornment, {
        position: "end"
      }, React.createElement(IconButton, {
        onClick: event => {
          event.stopPropagation(); // This is needed to keep the DateTimePicker from being opened

          onChange('');
        }
      }, React.createElement(Cancel, null))) : undefined
    },
    inputProps: {
      'aria-label': props.label
    }
  }, props))));
};

DateTimePicker.propTypes = {
  clearable: PropTypes.bool,
  dateOnly: PropTypes.bool,
  icon: PropTypes.element,
  initialFocusedDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  label: PropTypes.string.isRequired,
  maxDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  minDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  timeOnly: PropTypes.bool,
  timezone: PropTypes.string,
  valueFormat: PropTypes.string
};

const LinkedDateTimePicker = props => {
  const helpers = useFormHelpers(props);
  return React.createElement(DateTimePicker, helpers);
};

LinkedDateTimePicker.propTypes = {
  name: PropTypes.string.isRequired
};
export { DateTimePicker, LinkedDateTimePicker };